import { writeInObj } from 'utils/utils';

export function autoPopulateTransactionLookupValue(form, transactionToSubmit) {
    const {
        form: { values, automation },
        formConfig,
    } = form;
    const companyDataField = 'person.companyName';
    const filledTransactionToSubmit = structuredClone(transactionToSubmit);

    const companyFormFieldConfig = formConfig?.fields?.find((v) => v.dataField === companyDataField);
    const { lookup: { dataSource, displayExpr, referenceExpr } = {}, referenceField } = companyFormFieldConfig || {};

    if (!referenceField || !referenceExpr || !Array.isArray(dataSource) || dataSource.length === 0) {
        return filledTransactionToSubmit;
    }

    // The ONLY acceptable companyId is a real organizationId present in the company lookup. A numeric
    // company NAME (e.g. "205519" OCR'd/copied into the free-solo companyName field) is numeric and
    // would otherwise pass the old `!isNaN` check and reach the backend as a non-existent company id
    // Build the set of valid ids once and validate every candidate against it.
    const validCompanyIds = new Set(
        dataSource
            .map((company) => company?.[referenceExpr])
            .filter((id) => id !== null && id !== undefined)
            .map((id) => String(id))
    );
    const isValidCompanyId = (id) => id !== null && id !== undefined && id !== '' && validCompanyIds.has(String(id));

    const currentCompanyId = filledTransactionToSubmit?.person?.companyId;

    // Reconcile the companyId (not only when missing): keep an already-valid id; otherwise resolve it
    // from the company NAME the operator sees (displayExpr match); otherwise fall back to the
    // automation-provided id - but ONLY when that candidate resolves to a real organization.
    let resolvedCompanyId;
    if (isValidCompanyId(currentCompanyId)) {
        resolvedCompanyId = currentCompanyId;
    } else {
        const idFromName = dataSource.find((company) => company?.[displayExpr] === values?.[companyDataField])?.[referenceExpr];
        const idFromAutomation = automation?.[companyDataField]?.originalValue;
        resolvedCompanyId = isValidCompanyId(idFromName) ? idFromName : isValidCompanyId(idFromAutomation) ? idFromAutomation : null;
    }

    writeInObj(filledTransactionToSubmit, referenceField, resolvedCompanyId);
    return filledTransactionToSubmit;
}

export const populateInventoryDataAutomation = (transaction, form) => {
    const updatedTransaction = { ...transaction };
    const automationData = form?.form?.automation;
    const formConfig = form?.formConfig;

    Object.entries(automationData).forEach(([key, value]) => {
        const keys = key.split('.');
        const category = keys[0];
        const field = keys[1];
        if (!category || !field) return;
        // Only update if the property is null or undefined
        // We prioritize data input from the user than the automation
        if (!updatedTransaction[category]) {
            updatedTransaction[category] = {};
        }
        if (updatedTransaction[category][field]) return;

        const fieldConfig = formConfig?.fields?.find((field) => field.dataField === key);
        const lookupFieldConfig = fieldConfig?.lookup;
        if (!lookupFieldConfig) return;
        const { dataSource, displayExpr, valueExpr } = lookupFieldConfig;
        if (!dataSource) {
            updatedTransaction[category][field] = value?.sourceValue || '';
            return;
        }

        const lookupValue = dataSource.find((item) => item[displayExpr] === value?.sourceValue);
        updatedTransaction[category][field] = lookupValue?.[valueExpr] || '';
    });

    return updatedTransaction;
};
